import { render, staticRenderFns } from "./fcm.vue?vue&type=template&id=5201fed6&scoped=true"
import script from "./fcm.vue?vue&type=script&lang=js"
export * from "./fcm.vue?vue&type=script&lang=js"
import style0 from "./fcm.vue?vue&type=style&index=0&id=5201fed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201fed6",
  null
  
)

export default component.exports